<template>
  <div class="ci-root" v-click-outside="closeDropdown">

    <input
      :disabled="disabled"
      class="ci-input ci-input--code"
      placeholder="课程代码"
      v-model="Course.CourseCode"
      @input="onInput"
      @focus="onFocus"
    />

    <span class="ci-sep">-</span>

    <input
      :disabled="disabled"
      class="ci-input ci-input--name"
      placeholder="课程名称"
      v-model="Course.CourseName"
      @input="onInput"
      @focus="onFocus"
    />

    <div v-show="dropdownVisible && filteredList.length" class="ci-dropdown">
      <div
        v-for="item in filteredList"
        :key="item.ID"
        class="ci-option"
        @mousedown.prevent="selectItem(item)"
      >
        <span class="ci-option-code">{{ item.CourseCode }}</span>
        <span class="ci-option-name">{{ item.CourseName }}</span>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'CourseInput',

  model: { prop: 'Course', event: 'change' },

  directives: {
    clickOutside: {
      bind(el, binding) {
        el._clickOutside = e => { if (!el.contains(e.target)) binding.value() }
        document.addEventListener('mousedown', el._clickOutside)
      },
      unbind(el) {
        document.removeEventListener('mousedown', el._clickOutside)
      }
    }
  },

  props: {
    disabled: { default: false },
    Course: {
      type: Object,
      default: () => ({ CourseName: '', CourseCode: '' })
    }
  },

  data() {
    return {
      courseslist:     [],
      dropdownVisible: false,
      query:           ''
    }
  },

  computed: {
    filteredList() {
      if (!this.query) return this.courseslist.slice(0, 50)
      const q = this.query.toLowerCase()
      return this.courseslist.filter(s =>
        s.CourseCode.toLowerCase().includes(q) ||
        s.CourseName.toLowerCase().includes(q)
      ).slice(0, 50)
    }
  },

  watch: {
    Course: {
      handler(val) { this.$emit('change', val) },
      deep: true
    }
  },

  methods: {
    onFocus() {
      this.getCourses().then(() => {
        this.dropdownVisible = true
      })
    },

    onInput() {
      this.query = (this.Course.CourseCode + ' ' + this.Course.CourseName).trim()
      this.dropdownVisible = true
    },

    selectItem(item) {
      this.Course.CourseCode = item.CourseCode
      this.Course.CourseName = item.CourseName
      this.$emit('change', this.Course)
      this.dropdownVisible = false
      this.query = ''
    },

    closeDropdown() {
      this.dropdownVisible = false
    },

    getCourses() {
      if (this.courseslist.length) return Promise.resolve()
      return this.$store.dispatch('common/getcourses').then(res => {
        this.courseslist = res.courses
      })
    }
  }
}
</script>

<style scoped>
.ci-root {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  background: #fff;
  border: 0.5px solid #dcdfe6;
  border-radius: 6px;
  overflow: visible;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
}
.ci-root:focus-within {
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64,158,255,0.1);
}

.ci-input {
  border: none;
  outline: none;
  background: transparent;
  height: 32px;
  line-height: 32px;
  padding: 0 10px;
  font-size: 12px;
  color: #333;
  box-sizing: border-box;
  font-family: inherit;
}
.ci-input::placeholder { color: #bbb; }
.ci-input:disabled {
  color: #c0c4cc;
  cursor: not-allowed;
  background: #f5f7fa;
}

.ci-input--code {
  flex: 0 0 130px;
  font-weight: 600;
  color: #0C447C;
  background: #fafafa;
  border-right: 0.5px solid #f0f0f0;
  border-radius: 6px 0 0 6px;
}
.ci-input--code:disabled { border-radius: 6px 0 0 6px; }

.ci-sep {
  flex-shrink: 0;
  width: 20px;
  text-align: center;
  font-size: 14px;
  color: #ddd;
  background: #fafafa;
  border-right: 0.5px solid #f0f0f0;
  height: 32px;
  line-height: 32px;
  user-select: none;
}

.ci-input--name {
  flex: 1;
  min-width: 0;
  border-radius: 0 6px 6px 0;
}
.ci-input--name:disabled { border-radius: 0 6px 6px 0; }

/* 下拉列表 */
.ci-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 0.5px solid rgba(0,0,0,0.08);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.10);
  max-height: 260px;
  overflow-y: auto;
  z-index: 9999;
  padding: 4px;
}
.ci-dropdown::-webkit-scrollbar { width: 4px; }
.ci-dropdown::-webkit-scrollbar-thumb { background: #e0e0e0; border-radius: 2px; }
.ci-dropdown::-webkit-scrollbar-track { background: transparent; }

.ci-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 8px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.1s;
}
.ci-option:hover { background: #f5f5f5; }

.ci-option-code {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 600;
  color: #0C447C;
  background: #E6F1FB;
  padding: 1px 6px;
  border-radius: 4px;
  white-space: nowrap;
}

.ci-option-name {
  flex: 1;
  font-size: 12px;
  color: #444;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>